import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    maxWidth: "300px",
  },
  button: {
    justifyContent: "flex-start",
    height: "40px",
  },
});

export default useStyles;
